import { Route } from '@angular/router';
import { BuscadorPolizasView } from './salud/views/buscador-polizas/buscador-polizas.view';
import { DatosSolicitudView } from './salud/views/datos-solicitud/datos-solicitud.view';
import { solicitudGuard } from './salud/guard/solicitud.guard';
import { LoginView } from './login/views/login/login.view';
import { authGuard } from './comun/guard/auth.guard';
import { InicioView } from './comun/views/inicio/inicio.view';
import { AutoLoginComponent } from './login/components/auto-login/auto-login.component';
import { ErrorView } from './comun/views/error/error.view';
import { BuscadorModelosView } from './autos/views/buscador-modelos/buscador-modelos.view';
import { SimularAutosView } from './autos/views/simular-autos/simular-autos.view';
import { simulacionAutosGuard } from './autos/guard/simulacion-autos.guard';
import { GuardarProyectoView } from './comun/views/guardar-proyecto/guardar-proyecto.view';
import { ContratarPolizaView } from './comun/views/contratar-poliza/contratar-poliza.view';
import { PaquetesVentaCruzadaView } from './comun/views/paquetes-venta-cruzada/paquetes-venta-cruzada.view';
import { DatosSimulacionSaludView } from './salud/views/datos-simulacion-salud/datos-simulacion-salud.view';
import { TarificarSaludView } from './salud/views/tarificar-salud/tarificar-salud.view';
import { DatosSimulacionDentalView } from './salud/views/datos-simulacion-dental/datos-simulacion-dental.view';
import { GuardarMultiProyectoView } from './salud/views/guardar-multi-proyecto/guardar-multi-proyecto.view';
import { PymesSaludComponent } from './salud/views/pymes-salud/pymes-salud.component';
import { PymesCoberturasComponent } from './salud/components/pymes/producto-destacado/pymes-coberturas/pymes-coberturas.component';
import { PymesInfoProductoComponent } from './salud/components/pymes/producto-destacado/pymes-info-producto/pymes-info-producto.component';

export const appRoutes: Route[] = [
  { path: 'buscar-solicitud', component: BuscadorPolizasView, canActivate: [authGuard] },
  {
    path: 'buscar-solicitud/datos-solicitud',
    canActivate: [authGuard, solicitudGuard],
    component: DatosSolicitudView,
  },
  {
    path: 'autos/simular',
    component: BuscadorModelosView,
    canActivate: [authGuard],
  },
  {
    path: 'autos/tarificar',
    component: SimularAutosView,
    canActivate: [authGuard, simulacionAutosGuard]
  },
  {
    path: 'guardar-proyecto',
    component: GuardarProyectoView,
    canActivate: [authGuard],
  },
  {
    path: 'contratar-poliza',
    component: ContratarPolizaView,
    canActivate: [authGuard],
  },
  { path: 'autologin/:token', component: AutoLoginComponent },
  { path: 'paquetes-venta-cruzada/:idPack', component: PaquetesVentaCruzadaView },
  { path: 'salud/simular', component: DatosSimulacionSaludView, canActivate: [authGuard] },
  { path: 'dental/simular', component: DatosSimulacionDentalView, canActivate: [authGuard] },
  { path: 'salud/tarificar-recomendador', component: TarificarSaludView, canActivate: [authGuard] },
  { path: 'salud/pymes', component: PymesSaludComponent, canActivate: [authGuard] },
  // { path: 'salud/pymes/ahorro-fiscal', component: AhorroFiscalComponent, canActivate: [authGuard] },
  { path: 'salud/pymes/informacion-producto/:id', component: PymesInfoProductoComponent, canActivate: [authGuard] },
  // { path: 'salud/pymes/preguntas-frecuentes', component: PymesPreguntasFrequentesComponent, canActivate: [authGuard] },
  // { path: 'salud/pymes/objeciones-ventas', component: PymesObjecionesVentasComponent, canActivate: [authGuard] },
  // { path: 'salud/pymes/beneficios-seguro', component: PymesBeneficiosSeguroComponent, canActivate: [authGuard] },
  { path: 'salud/pymes/coberturas', component: PymesCoberturasComponent, canActivate: [authGuard] },
  { path: 'salud/guardar-multi-proyecto', component: GuardarMultiProyectoView, canActivate: [authGuard] },
  { path: 'login', component: LoginView },
  { path: 'error', component: ErrorView },
  { path: '', component: InicioView, canActivate: [authGuard] },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

